'use client';

import { Button, Portal } from '@common/components';
import { SvgDelete } from '@common/icon';
import dayjs from 'dayjs';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { DEFAULT_META, SELECTOR } from '@/constants';
import { useDeviceInfoStore } from '@/stores/DeviceStore';

export const DownloadAppBanner = () => {
  const [webviewType, osType] = useDeviceInfoStore(
    useShallow((state) => [state.webviewType, state.osType]),
  );

  const [isVisible, setIsVisible] = useState(false);

  const isMobileWeb =
    !webviewType && osType && ['ios', 'android'].includes(osType);

  useEffect(() => {
    if (!isMobileWeb) return;

    const lastClosed = localStorage.getItem('bannerLastClosed');
    const now = dayjs();

    if (!lastClosed || !dayjs(lastClosed).isSame(now, 'day')) {
      setIsVisible(true);
    }
  }, [isMobileWeb]);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('bannerLastClosed', dayjs().toISOString());
  };

  if (!isVisible) return null;

  return (
    <Portal renderTo={() => document.getElementById(SELECTOR.PAGE_NAV_WRAPPER)}>
      <aside className="flex items-center justify-between gap-8 bg-Gray-100 px-16 py-12">
        <div className="flex items-center gap-12 font-600 typo-caption1">
          <Image
            alt="Wello Logo"
            className="size-32"
            height={32}
            quality={100}
            src="/assets/pngs/wello-logo.png"
            width={32}
          />
          맞춤 정책 확인하고 리워드 받기
        </div>
        <div className="flex items-center gap-8">
          <Button asChild className="bg-B-500 hover:bg-B-600" dimensions="H26">
            <a
              href={
                osType === 'ios'
                  ? DEFAULT_META.appLinks.ios.url
                  : DEFAULT_META.appLinks.android.url
              }
              rel="noreferrer"
              target="_blank"
            >
              앱으로 보기
            </a>
          </Button>
          <button className="h-fit p-0" type="button" onClick={handleClose}>
            <SvgDelete className="size-12 text-Gray-700" name="close" />
          </button>
        </div>
      </aside>
    </Portal>
  );
};
